import { StatsigClient } from "@statsig/js-client";
import {
  runStatsigSessionReplay,
  StatsigSessionReplayPlugin,
} from "@statsig/session-replay";
import {
  runStatsigAutoCapture,
  StatsigAutoCapturePlugin,
} from "@statsig/web-analytics";
import { getStoredUser } from "../utils/storage";

const ENVIRONMENT = process.env.REACT_APP_ENV;
const SDK_KEY = process.env.REACT_APP_STATSIG_SDK_KEY || "";

export const statsigClient = new StatsigClient(
  SDK_KEY,
  { userID: getStoredUser()?.user.id },
  {
    plugins: [new StatsigSessionReplayPlugin(), new StatsigAutoCapturePlugin()],
    environment: { tier: ENVIRONMENT },
  }
);

runStatsigSessionReplay(statsigClient);
runStatsigAutoCapture(statsigClient);
(async () => await statsigClient.initializeAsync())();
